import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import { BorderRadius, Colors, FontSizes, FontWeights } from '../Theme';

const PowerSelect = ({
  creatable,
  disabled,
  formatCreateLabel,
  invalid,
  isMulti,
  newOptionCheck,
  noOptionsMessage,
  onChange,
  options,
  placeholder,
  required,
  value
}) => {
  const styles = {
    select: {
      control: () => ({
        alignItems: 'center',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: invalid ? Colors.RED.hex : '#ccc',
        borderRadius: BorderRadius.DEFAULT,
        width: '100%',
        background: disabled ? '#f5f5f5' : '#fff',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        fontSize: FontSizes.REGULAR,
        justifyContent: 'space-between',
        minHeight: 40,
        position: 'relative',
        padding: '3px 0px'
      }),
      menu: provider =>
        Object.assign({}, provider, {
          borderRadius: 2,
          lineHeight: '1.6em',
          fontSize: FontSizes.REGULAR,
          zIndex: 2
        }),
      multiValue: provider =>
        Object.assign({}, provider, {
          backgroundColor: Colors.PRIMARY.hex,
          borderRadius: 3,
          padding: '5px 4px 5px 8px',
          display: 'flex',
          justifyContent: 'space-between',
          margin: '2px 4px 2px 0px'
        }),
      multiValueLabel: provider =>
        Object.assign({}, provider, {
          color: '#fff',
          fontSize: FontSizes.REGULAR,
          fontWeight: FontWeights.BOLD,
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          margin: 0
        }),
      multiValueRemove: provider =>
        Object.assign({}, provider, {
          color: '#fff',
          paddingLeft: 2,
          paddingTop: 0,
          paddingRight: 2,
          paddingBottom: 0,
          marginLeft: 4,
          cursor: 'pointer'
        })
    },
    required: {
      position: 'absolute',
      right: 5,
      top: 5,
      color: Colors.RED.hex
    }
  };
  const components = {
    IndicatorSeparator: null
  };

  if (!options) {
    components.DropdownIndicator = null;
  }

  return (
    <div style={{ position: 'relative', height: 'inherit' }}>
      {creatable ? (
        <CreatableSelect
          components={components}
          formatCreateLabel={formatCreateLabel || (inputValue => `Add "${inputValue}"`)}
          isClearable={false}
          isDisabled={disabled}
          isMulti={isMulti}
          isValidNewOption={newOptionCheck}
          noOptionsMessage={() => noOptionsMessage}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          styles={styles.select}
          value={value}
        />
      ) : (
        <Select
          components={components}
          isClearable={false}
          isDisabled={disabled}
          isMulti={isMulti}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          styles={styles.select}
          value={value}
        />
      )}
      {required ? <span style={styles.required}>*</span> : null}
    </div>
  );
};

PowerSelect.propTypes = {
  creatable: PropTypes.bool,
  disabled: PropTypes.bool,
  formatCreateLabel: PropTypes.func,
  invalid: PropTypes.bool,
  isMulti: PropTypes.bool,
  newOptionCheck: PropTypes.func,
  noOptionsMessage: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ])
};

export default PowerSelect;
